<template>
  <el-tooltip placement="top-start" trigger="hover" trig effect="customized" popper-class="merge-tooltip">
    <div class="merge-tag">{{ $t('mergedDiscussion') }}</div>
    <template #content>
      <div class="merge-text">{{$t('mergeText')}}</div>
    </template>
  </el-tooltip>
</template>

<style lang="postcss" scoped>
  .merge-tag {
    font-size: 12px;
    color: var(--color-text-disabled);
    margin-top: 8px;
    cursor: pointer;
  }

  .merge-text {
    padding: 2px 6px;
    max-width: 212px;
    font-size: 14px;
    color: var(--color-text-secondary);
  }
</style>
<style>
  .merge-tooltip {
    box-shadow: 0 2px 12px rgba(50,50,51,.12);
    background: var(--color-background-secondary);
  }

  .merge-tooltip .el-popper__arrow {
    display: block !important;
  }

  .merge-tooltip .el-popper__arrow::before {
    background: var(--color-background-secondary);

  }
</style>